import React from 'react';
import BoxContainer from '../../style-components/BoxContainer.jsx';
import HeaderContainer from '../../style-components/HeaderContainer.jsx';
import { AIChatView } from './AIChatView.jsx';
import CloseIcon from '@mui/icons-material/Close';

const AIChat = ({ onClose = () => { }, open = true }) => {

  const actions = [
    {
      title: 'Cerrar',
      icon: <CloseIcon />,
      handleClick: onClose,
    },
  ];

  return (
    <BoxContainer>
      <div className="divide-y divide-primary max-h-screen h-[95vh] flex flex-col">
        <HeaderContainer title='Chat IA' actions={actions} />
        <div className="flex-1 min-h-0">
          <AIChatView open={open} />
        </div>
      </div>
    </BoxContainer>
  );
};

export default AIChat;